export default {
	setBetDetail({commit}, url) {
		commit('setBetDetail', url)
	},
	resetBetDetail({commit}) {
		commit('resetBetDetail')
	}
}
